import { RDEqipReviewRecommendationResults } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { RDEqipReviewRecommendationResultsTaskEditor } from './RDEqipReviewRecommendationResultsTaskEditor'

export const RDEqipReviewRecommendationResultsResourceDetailFeature: ResourceDetailFeature<RDEqipReviewRecommendationResults> =
  {
    traitId: 'eqipReviewRecommendationResults',
    TaskEditor: RDEqipReviewRecommendationResultsTaskEditor,
  }
